/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cookie_SettingsInputs */

const en_landing_cookie_settings = /** @type {(inputs: Landing_Cookie_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie Settings`)
};

const de_landing_cookie_settings = /** @type {(inputs: Landing_Cookie_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie-Einstellungen`)
};

const fr_landing_cookie_settings = /** @type {(inputs: Landing_Cookie_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parametres des cookies`)
};

const es_landing_cookie_settings = /** @type {(inputs: Landing_Cookie_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuracion de cookies`)
};

const it_landing_cookie_settings = /** @type {(inputs: Landing_Cookie_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni cookie`)
};

const nl_landing_cookie_settings = /** @type {(inputs: Landing_Cookie_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie-instellingen`)
};

const pl_landing_cookie_settings = /** @type {(inputs: Landing_Cookie_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustawienia plikow cookie`)
};

const fi_landing_cookie_settings = /** @type {(inputs: Landing_Cookie_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaesteasetukset`)
};

const da_landing_cookie_settings = /** @type {(inputs: Landing_Cookie_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie-indstillinger`)
};

const sv_landing_cookie_settings = /** @type {(inputs: Landing_Cookie_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookieinstaellningar`)
};

/**
* | output |
* | --- |
* | "Cookie Settings" |
*
* @param {Landing_Cookie_SettingsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_cookie_settings = /** @type {((inputs?: Landing_Cookie_SettingsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cookie_SettingsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_cookie_settings(inputs)
	if (locale === "fr") return fr_landing_cookie_settings(inputs)
	if (locale === "es") return es_landing_cookie_settings(inputs)
	if (locale === "it") return it_landing_cookie_settings(inputs)
	if (locale === "nl") return nl_landing_cookie_settings(inputs)
	if (locale === "pl") return pl_landing_cookie_settings(inputs)
	if (locale === "fi") return fi_landing_cookie_settings(inputs)
	if (locale === "da") return da_landing_cookie_settings(inputs)
	if (locale === "sv") return sv_landing_cookie_settings(inputs)
	return en_landing_cookie_settings(inputs)
});